// import { report } from "process";
import { dashboardAction, ReportManagements } from "../actionTypes";
const initialState = {
    dashboardData:[],
    loader: false,
    transactionReportData:[],
    adminPaymentReportsData:[],
    orderReportData:[],
    productReportData:[]
    
}

export default function dashboard(state = initialState, {type, payload}) {
    switch(type) {
   
      case dashboardAction.OWNER_DASHBOARD_INITIATE: {
        return {
          ...state, dashboardData: []
        }
      }
      case dashboardAction.OWNER_DASHBOARD_SUCCESS: {
        return {
          ...state, dashboardData:payload
        }
      }
      case dashboardAction.OWNER_DASHBOARD_FAILURE: {
        return {
          ...state, dashboardData: []
        }
      }


      case ReportManagements.TRANSACTION_REPORT_INITIATE: {
        return {
          ...state, transactionReportData: []
        }
      }
      case ReportManagements.TRANSACTION_REPORT_SUCCESS: {
        return {
          ...state, transactionReportData:payload
        }
      }
      case ReportManagements.TRANSACTION_REPORT_FAILURE: {
        return {
          ...state, transactionReportData: payload
        }
      }
      case ReportManagements.ADMIN_PAYMENT_REPORT_INITIATE: {
        return {
          ...state, adminPaymentReportsData: []
        }
      }
      case ReportManagements.ADMIN_PAYMENT_REPORT_SUCCESS: {
        return {
          ...state, adminPaymentReportsData:payload
        }
      }
      case ReportManagements.ADMIN_PAYMENT_REPORT_FAILURE: {
        return {
          ...state, adminPaymentReportsData: payload
        }
      }

      case ReportManagements.ORDER_REPORT_INITIATE: {
        return {
          ...state, orderReportData: []
        }
      }
      case ReportManagements.ORDER_REPORT_SUCCESS: {
        return {
          ...state, orderReportData:payload
        }
      }
      case ReportManagements.ORDER_REPORT_FAILURE: {
        return {
          ...state, orderReportData: payload
        }
      }

      case ReportManagements.PRODUCT_REPORT_INITIATE: {
        return {
          ...state, productReportData: []
        }
      }
      case ReportManagements.PRODUCT_REPORT_SUCCESS: {
        return {
          ...state, productReportData:payload
        }
      }
      case ReportManagements.PRODUCT_REPORT_FAILURE: {
        return {
          ...state, productReportData: payload
        }
      }

  
      default: 
      return state
  }
  }